// @flow
import * as React from 'react';
import i18n from 'app/common/lib/i18n';
import ScrollFetch from 'app/common/react/components/BoardEdit/BoardInvites/ScrollFetch';
import { type Invite } from 'app/common/react/components/BoardCollab/types';
import { Box, Spinner } from 'gestalt';

type Props = {
  fetchMore: () => void,
  invites: Array<Invite>,
  isAtEnd: boolean,
  isFetching: boolean,
  onBoardLeave: () => void,
  refreshData: () => void,
  scroll: ?{
    container: HTMLElement,
    top: number,
  },
  renderInvite: (
    invite: Invite,
    onBoardLeave: () => void,
    onInviteDidUpdate: () => void,
  ) => React.Node,
};

export default function BoardInvites(props: Props) {
  const {
    fetchMore,
    invites,
    isAtEnd,
    isFetching,
    onBoardLeave,
    refreshData,
    scroll,
    renderInvite,
  } = props;

  return (
    <div>
      {scroll && (
        <ScrollFetch
          scrollBuffer={scroll.container.clientHeight * 3}
          scrollHeight={scroll.container.scrollHeight}
          scrollTop={scroll.top}
          isAtEnd={isAtEnd}
          isFetching={isFetching}
          fetchMore={fetchMore}
        />
      )}
      {invites.map(
        (invite, idx) =>
          !!invite && !!invite.invited_user && !!invite.invited_user.id ? (
            <Box key={idx}>{renderInvite(invite, onBoardLeave, refreshData)}</Box>
          ) : null,
      )}
      {isFetching &&
        !isAtEnd && (
          <Spinner
            accessibilityLabel={i18n._(
              'loading board invites',
              'accessibility label for board collaborator invites loading spinner',
            )}
            show
          />
        )}
    </div>
  );
}
